import { DropdownFilterChip } from "@components/common/faro-table/faro-table-filter/dropdown-filter-chip";
import { useProjectMarkupsFilterLists } from "@pages/project-details/project-markups/project-markups-filters/project-markups-filter-list";
import { ProjectMarkupsTableHeaders } from "@pages/project-details/project-markups/project-markups-table-utils";
import { TableType } from "@utils/track-event/track-event-list";

/** Show filters and apply them for project markup assignee */
export function ProjectMarkupsAssigneeFilter(): JSX.Element {
  const allFilters = useProjectMarkupsFilterLists();

  return (
    <DropdownFilterChip
      label={ProjectMarkupsTableHeaders.assignee}
      filteredColumn={ProjectMarkupsTableHeaders.assignee}
      items={allFilters.Assignee ?? {}}
      shouldShowSearchBox={true}
      shouldShowCheckbox={true}
      tableType={TableType.projectMarkups}
      size="large"
    />
  );
}
